export default "__VITE_PUBLIC_ASSET__e593045d__"